import styles from './PaginaErro.module.css'

export default function PaginaErro() {
  return (
    <h2 className={styles.erro}>Erro pagina não encontrada!</h2>
  )
}
